export const DESIGNATE_CREATE_REQUEST = 'DESIGNATE_CREATE_REQUEST'
export const DESIGNATE_CREATE_SUCCESS = 'DESIGNATE_CREATE_SUCCESS'
export const DESIGNATE_CREATE_FAIL = 'DESIGNATE_CREATE_FAIL'
export const DESIGNATE_CREATE_RESET = 'DESIGNATE_CREATE_RESET'


export const LIST_DESIGNATE_REQUEST = 'LIST_DESIGNATE_REQUEST'
export const LIST_DESIGNATE_SUCCESS = 'LIST_DESIGNATE_SUCCESS'
export const LIST_DESIGNATE_FAIL = 'LIST_DESIGNATE_FAIL'
export const LIST_DESIGNATE_RESET = 'LIST_DESIGNATE_RESET'



export const DESIGNATE_DELETE_REQUEST = 'DESIGNATE_DELETE_REQUEST'
export const DESIGNATE_DELETE_SUCCESS = 'DESIGNATE_DELETE_SUCCESS'
export const DESIGNATE_DELETE_FAIL = 'DESIGNATE_DELETE_FAIL'

export const DESIGNATE_UPDATE_REQUEST = 'DESIGNATE_UPDATE_REQUEST'
export const DESIGNATE_UPDATE_SUCCESS = 'DESIGNATE_UPDATE_SUCCESS'
export const DESIGNATE_UPDATE_FAIL = 'DESIGNATE_UPDATE_FAIL'
export const DESIGNATE_UPDATE_RESET = 'DESIGNATE_UPDATE_RESET'


export const DESIGNATE_DETAILS_REQUEST = 'DESIGNATE_DETAILS_REQUEST'
export const DESIGNATE_DETAILS_SUCCESS = 'DESIGNATE_DETAILS_SUCCESS'
export const DESIGNATE_DETAILS_FAIL = 'DESIGNATE_DETAILS_FAIL'